import $ from 'jquery';

import MegaNavScroller from './MegaNavScroller';
import scrollLeft from '../helpers/scrollLeft';

export default class NavDesktop {
  constructor(options) {
    this.$el = $(options.$el);
    this.postMessage = options.postMessage;

    this.activeMenu = 'navmenu-active';
    this.activeItem = 'navmenu-item-active';
    this.navTrigger = '[data-navmenu-trigger]';
    this.subMenu = '[data-navmenu-submenu]';

    this.inlineChildren = 'navmenu-submenu-inline-children';

    this.events = [
      // Navmenu mouse events
      this.$el.on('mousedown.navmenu', '.navmenu-link', event => {
        event.preventDefault();

        // Add a class to actively clicked item to prevent focus styling
        const $target = $(event.currentTarget);

        this.$el.find(`.${this.activeItem}`).removeClass(this.activeItem);

        $target.addClass(this.activeItem).attr('aria-expanded', true);
      }),

      this.$el.on('mouseup.navemenu, click.navmenu', `${this.navTrigger} > .navmenu-link-parent`, event => {
        // Mouseup and click fire after mousedown
        return event.preventDefault();
      }),

      this.$el.on('mousedown.navmenu', `${this.navTrigger} > .navmenu-link-parent`, event => {
        event.preventDefault();

        const $target = $(event.currentTarget);

        if ($target.is(':focus')) {
          $target.data('clicked', true);
        }

        this.toggleItem(event.currentTarget.parentNode);
      }),

      // Toggle item on touch, and click
      this.$el.on('touchend.navmenu', `${this.navTrigger} > .navmenu-link-parent`, event => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleItem(event.currentTarget.parentNode);
      }),

      // Keyboard navigation -- toggle submenus
      this.$el.on('focus.navmenu', `${this.navTrigger} > .navmenu-link-parent`, event => {
        event.stopPropagation();

        const $target = $(event.currentTarget);
        const clicked = $target.data('clicked');

        // Prevent focus by click to fire a subsequent toggle
        if (clicked) {
          $target.removeData('clicked');
        } else {
          this.toggleItem(event.currentTarget.parentNode);
        }
      }),

      // Keyboard navigation -- close submenus when moving to a new nav item
      this.$el.on('focus.navmenu', '.navmenu-depth-1 > .navmenu-item .navmenu-link', event => {
        this.closeAll(event.currentTarget);
      }),

      // Close items when clicking outside
      // $(document).on('touchstart.navmenu, click.navmenu', event => {
      //   this._handleDocumentClick(event.target);
      // }),
    ];
  }

  unload() {
    this.events.forEach($el => $el.off('.navmenu'));

    if (this.megaNav) {
      delete this.megaNav;
    }
  }

  /**
   * Open the MegaNav
   * @param $menu
   * @param block
   */
  openMegaNav($menu, block) {
    this.megaNav = new MegaNavScroller($menu, block);
  }

  /**
   * Open a dropdown menu, or scroll to a meganav item
   *
   * @param el - Parent LI containing sub menu
   * @param block - Meganav menu block
   */
  openItem(el, block = null) {
    const $el = $(el);

    // Check if menu is already open
    const $menu = $el.children(this.subMenu);
    if ($menu.is(':visible')) {
      // If its not a meganav, do nothing
      if ($menu.attr('data-meganav-menu') === undefined) return;

      // If its a meganav, scroll horizontally to the item
      scrollLeft($(block.el));
      return;
    }

    // Close previously opened items
    this.closeAll(el);

    $el.data('transitioning', true);
    const $parent = $menu.parent(this.navTrigger);

    // Add an active class to the menu's parent
    $parent
      .find('.navmenu-link-parent:first')
      .addClass(this.activeMenu);

    // Show menu
    $menu
      .addClass('animating animating-in')
      .one('trend', () => {
        $menu
          .removeClass('animating animating-in')
          .addClass('visible')
          .off('trend');

        this._inlineMenu($menu);

        $el.data('transitioning', false);
        $parent.find('> .navmenu-link').attr('aria-expanded', true);

        // Load MegaNavScroller if is a mega nav
        if ($menu.attr('data-meganav-menu') !== undefined) {
          this.openMegaNav($menu, block);
        }
      });
  }

  closeAll(target) {
    this.$el.find(`${this.subMenu}.visible, ${this.subMenu}.animating-in`).parent(this.navTrigger).each((i, el) => {
      if (target && $.contains(el, target)) return;

      // Close any submenus in this tree
      $(el)
        .find(this.navTrigger)
        .each((i, submenu) => this.closeItem(submenu));

      // Close root-level menu item
      this.closeItem(el);
    });
  }

  closeItem(el) {
    const $el = $(el);
    const $menu = $el.children(`${this.subMenu}.visible, ${this.subMenu}.animating-in`);
    const $parent = $menu.parent(this.navTrigger);
    if (!$menu.length) return;

    // Menu is in the progress of being animated, try in 300ms
    if($el.data('transitioning')) {
      setTimeout(() => {
        return this.closeItem(el);
      }, 300);
    }

    // Add an active class to the menu's parent
    $parent
      .find('.navmenu-link-parent:first')
      .removeClass(this.activeMenu);

    // Ensure $menu is scrolled to top
    if ($menu.hasClass(this.inlineChildren)) {
      $menu.scrollTop(0);
    }

    // Hide menu
    $menu
      .addClass('animating animating-out')
      .removeClass('animating-in')
      .one('trend', () => {
        $menu
          .removeClass('animating animating-out visible')
          .off('trend');

        $parent.find('> .navmenu-link').attr('aria-expanded', false);

        // Unload MegaNavScroller if is a mega-nav
        if ($menu.data('meganav-menu') !== undefined && this.megaNav) {
          this.megaNav.unload();
          this.megaNav = null;
        }
      });
  }

  toggleItem(el) {
    const $el = $(el);
    const $menu = $el.children(this.subMenu);

    if ($menu.is(':visible')) {
      this.closeItem(el);
    } else {
      this.openItem(el);
    }
  }

  _handleDocumentClick(target) {
    const $parent = $(target).parents(this.navTrigger);
    if ($parent.length) return;

    this.closeAll();
  }

  _menuLimits($menu) {
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const menuRect = $menu[0].getBoundingClientRect();
    const hasChildren = $menu.find(this.subMenu).length > 0;
    const stickyHeaderOffset = $('.site-header-sticky--scrolled').length ? 20 : 0; // Padding difference
    const edges = {
      bottomEdge: menuRect.bottom + stickyHeaderOffset,
      rightEdge: menuRect.right + menuRect.width,
    };

    // Store bottom offset for subsequent openings
    if (!$menu.data('bottom-edge') || $menu.data('bottom-edge') !== edges.bottomEdge) {
      $menu.data('bottom-edge', edges.bottomEdge);
    }

    // Store child menu right edge
    if (!$menu.data('right-edge') || $menu.data('right-edge') !== edges.rightEdge) {
      $menu.data('right-edge', edges.rightEdge);
    }

    const bottomEdge = parseInt($menu.data('bottom-edge'), 10);
    const rightEdge = parseInt($menu.data('right-edge'), 10);

    return {
      childrenExceedHorizontal: rightEdge >= windowWidth && hasChildren,
      exceedsVertical: bottomEdge >= windowHeight,
      maxHeight: windowHeight - menuRect.top,
    };
  }

  /**
   * Set a menu to be
   */
  _inlineMenu($menu) {
    const { childrenExceedHorizontal, exceedsVertical, maxHeight } = this._menuLimits($menu);

    // Unset inline style if height allows, and children menu don't exceed window bounds
    if (!exceedsVertical && !childrenExceedHorizontal) {
      return this._unsetInlineMenu($menu);
    }

    return $menu.css({ maxHeight }).addClass(this.inlineChildren);
  }

  _unsetInlineMenu($menu) {
    $menu
      .removeAttr('data-bottom-edge')
      .removeAttr('data-right-edge')
      .removeClass(this.inlineChildren)
      .css('max-height', '');
  }
}
